module.exports = __webpack_public_path__ + "img/retry.153fea74.svg";